// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-menu-button {
  --padding-top: 4px;
}
:host ion-button {
  --padding-top: 4px;
}
:host .venue-filter-button {
  margin-bottom: 11px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
